import { NotFound } from '@sorare/routing';

const CatchAllPage = () => {
  return <NotFound />;
};
export default CatchAllPage;
